/* Holographic shimmer clock — drives ONE shared --holo-shine value (a sweeping
   0%→100% background-position) onto every shimmering element so they all glint at
   the exact same time and in the same direction: the header logo, the footer
   brand logo, and the homepage category headings. A single requestAnimationFrame
   loop, phase-locked to performance.now(), so any element that pauses and is
   re-revealed rejoins the sweep in phase. The loop pauses when the tab is hidden,
   a modal holds body.overflow-hidden, or no shimmer target is on screen. Respects
   prefers-reduced-motion (parks the glint mid-sweep). No dependencies, no globals. */
(function () {
  var DURATION = 3200; /* ms per sweep — matches the logo + the 3.2s brand cadence */
  var targets = [];
  var visible = [];
  var running = false;
  var coarse = false; /* touch devices: shimmer still moves, throttled (see init) */
  var tick = 0;

  function anyVisible() {
    for (var i = 0; i < visible.length; i++) {
      if (visible[i]) return true;
    }
    return false;
  }

  function frame(now) {
    if (document.hidden || !anyVisible()) {
      running = false;
      return;
    }
    // While the cart drawer (or any overflow-hidden modal) is open, skip the
    // shine writes — repainting masked/clipped shimmers competes with the slide.
    // The loop stays alive and resumes the instant it closes.
    // Touch devices write every 3rd frame at half speed (~20fps, gentler sweep):
    // visible motion at roughly a third of the re-rasterization cost.
    if (!document.body.classList.contains('overflow-hidden') && (!coarse || ++tick % 3 === 0)) {
      var dur = coarse ? DURATION * 2 : DURATION;
      var shine = ((now % dur) / dur * 100).toFixed(2) + '%';
      for (var i = 0; i < targets.length; i++) {
        targets[i].style.setProperty('--holo-shine', shine);
      }
    }
    window.requestAnimationFrame(frame);
  }

  function start() {
    if (!running && !document.hidden && anyVisible()) {
      running = true;
      window.requestAnimationFrame(frame);
    }
  }

  function collect() {
    // Category headings ONLY. The header/footer logo glints are driven by the CSS
    // logo-glint keyframe animation, which owns background-position outright — CSS
    // animations beat the var-driven declaration, so writing --holo-shine to the
    // logos was pure dead work on every frame. Don't collect them.
    return Array.prototype.slice.call(
      document.querySelectorAll('.collection__title h2.title')
    );
  }

  function park() {
    for (var i = 0; i < targets.length; i++) {
      targets[i].style.setProperty('--holo-shine', '50%');
    }
  }

  function init() {
    targets = collect();
    if (!targets.length) return;

    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      park();
      return;
    }
    // Touch devices: full-rate animation forced WebKit to re-rasterize the headings
    // every frame, but parking the shimmer entirely read as "broken" (static). Run
    // it throttled instead — the frame() loop drops to ~20fps at half speed.
    coarse = !!(window.matchMedia && window.matchMedia('(pointer: coarse)').matches);

    if ('IntersectionObserver' in window) {
      visible = targets.map(function () { return false; });
      var io = new IntersectionObserver(function (entries) {
        for (var i = 0; i < entries.length; i++) {
          var idx = targets.indexOf(entries[i].target);
          if (idx !== -1) visible[idx] = entries[i].isIntersecting;
        }
        start();
      });
      for (var j = 0; j < targets.length; j++) io.observe(targets[j]);
    } else {
      visible = targets.map(function () { return true; });
      start();
    }

    document.addEventListener('visibilitychange', function () {
      if (!document.hidden) start();
    });
  }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();
